import React from "react";

export default function GalleryModal({ isOpen, onClose, media, type }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center p-4">
      <div className="relative max-w-7xl w-full mx-auto">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 bg-black bg-opacity-50 rounded-full p-2 text-white hover:text-gray-300 z-50"
        >
          <svg
            className="w-8 h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <div className="relative w-full" onClick={(e) => e.stopPropagation()}>
          {type && type.includes("image") ? (
            <img
              src={media}
              alt=""
              className="w-full h-auto max-h-[90vh] object-contain"
            />
          ) : (
            <video
              className="w-full h-auto max-h-[90vh]"
              controls
              autoPlay
              playsInline
            >
              <source src={media} type={type} />
              <source src={media} type="video/quicktime" />
              <source src={media} type="video/mp4" />
              Your browser does not support video playback
            </video>
          )}
        </div>
      </div>
    </div>
  );
}
